import React from "react"
import GlobalHelper from "../../common/GlobalHelper"
import { Address } from "../../state/helpers/Address"


type Props = {
    value: Address
    lineStyle?: object
    localeWithoutRegionCode?: string
}

const AddressComponent = (props: Props) => {
    if (!props.value) {
        return ""
    }

    let { lineStyle, localeWithoutRegionCode } = props
    const { value } = props

    const address = value
    lineStyle = lineStyle || {}
    localeWithoutRegionCode = localeWithoutRegionCode || "en"
    return (
        <>
            {
                address.street &&
                <p key={"address-street1"} className="m-0 p-0" style={lineStyle}>
                    {address.street}
                </p>
            }
            {
                address.street2 &&
                <p key={"address-street1"} className="m-0 p-0" style={lineStyle}>
                    {address.street2}
                </p>
            }
            <p key={"address-text"} className="m-0 p-0" style={lineStyle}>
                {getFullAddressText(address, localeWithoutRegionCode)}
            </p>
        </>
    )
}

const getFullAddressText = (address, localeWithoutRegionCode) => {
    let formatedFullAddress = ""
    if (address.city) {
        formatedFullAddress += address.city
    }
    if (formatedFullAddress !== "") {
        formatedFullAddress += ", "
    }
    
    const stateCode = GlobalHelper.getStateCodeFromAddress(address, localeWithoutRegionCode)
    if (stateCode) {
        formatedFullAddress += stateCode
    }

    if (address.postalCode) {
        formatedFullAddress += " " + address.postalCode.toUpperCase()
    }
    if (address.countryCode) {
        formatedFullAddress += " " + address.countryCode.toUpperCase()
    }

    return formatedFullAddress
}

export default AddressComponent


// WEBPACK FOOTER //
// ./src/customer/components/AddressComponentSSR.tsx